export default __webpack_public_path__ + "static/media/caraivaIcon.26621ded.svg";